/* eslint-disable prettier/prettier */
import UilEdit from '@iconscout/react-unicons/icons/uil-edit';
import UilTrash from '@iconscout/react-unicons/icons/uil-trash';
import { Link } from 'react-router-dom';

export const columns = [
    {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
    },
    {
        title: 'Actions',
        dataIndex: 'action',
        key: 'action',
        width: '90px',
    },
];

// const DATA = [
//     {
//         id: 1,
//         firstName: "John",
//         lastName: "Doe",
//         email: "john.doe@example.com",
//         mobile: "123-456-7890"
//     },
//     {
//         id: 2,
//         firstName: "Jane",
//         lastName: "Smith",
//         email: "jane.smith@example.com",
//         mobile: "987-654-3210"
//     },
//     {
//         id: 3,
//         firstName: "David",
//         lastName: "Johnson",
//         email: "david.johnson@example.com",
//         mobile: "555-555-5555"
//     },
//     {
//         id: 4,
//         firstName: "Sarah",
//         lastName: "Davis",
//         email: "sarah.davis@example.com",
//         mobile: "111-111-1111"
//     },
//     {
//         id: 5,
//         firstName: "Michael",
//         lastName: "Wilson",
//         email: "michael.wilson@example.com",
//         mobile: "999-999-9999"
//     }
// ]



export const dataSource = (handleDelete, handleEdit,allData=[]) => allData.map((data) => {
    const { id, firstName, lastName, emailId } = data;

    return {
        key: id,
        firstName: <span className="text-body dark:text-white60 text-[15px] font-medium">{firstName}</span>,
        lastName: <span className="text-body dark:text-white60 text-[15px] font-medium">{lastName}</span>,
        email: <span className="text-body dark:text-white60 text-[15px] font-medium">{emailId}</span>,
        action: (
            <div className="min-w-[150px] text-end -m-2">
                <Link className="inline-block m-2" to="#">
                    <UilEdit to="#" onClick={() => handleEdit(data)} className="w-4 text-light-extra dark:text-white60" />
                </Link>
                <Link className="inline-block m-2" to="#">
                    <UilTrash to="#" onClick={() => handleDelete(id)} className="w-4 text-light-extra dark:text-white60" />
                </Link>
            </div>
        ),
    };
});